import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import { createContext, useContext, useState } from "react";
import { LoadingScreen } from "@flat-ui";
/** Context that provides the LoadingSpinnerProvider with function to show the loading spinner from anywhere */
const LoadingSpinnerContext = createContext(undefined);

/**
 * @returns A provider that allows components to show the app loading spinner from anywhere
 *
 * The App loading spinner cover the whole screen.
 */
export function LoadingSpinnerProvider(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  const [isLoadingSpinnerShowing, setLoadingSpinner] = useState(false);
  let t1;
  let t2;
  if ($[0] !== isLoadingSpinnerShowing) {
    t1 = {
      isLoadingSpinnerShowing,
      setLoadingSpinner
    };
    t2 = isLoadingSpinnerShowing && <Box component="div" role="loadingScreen" sx={{
      zIndex: "modal",
      position: "fixed",
      top: 0,
      bottom: 0,
      width: "100%",
      height: "100%",
      placeItems: "center",
      backgroundColor: "background.default",
      display: "grid"
    }}><LoadingScreen /></Box>;
    $[0] = isLoadingSpinnerShowing;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t1 || $[5] !== t2) {
    t3 = <LoadingSpinnerContext.Provider value={t1}>{t2}{children}</LoadingSpinnerContext.Provider>;
    $[3] = children;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
export function useLoadingSpinner() {
  const context = useContext(LoadingSpinnerContext);
  if (!context) {
    throw Error("useLoadingSpinner must be used inside the LoadingSpinnerProvider");
  }
  return context;
}